import { OrgAccountType } from '@dtx-company/true-common/src/types/org'
import { getFlowpageHost } from '@dtx-company/true-common/src/utils/urls/host'
import { selectCurrentUserPlan } from '@dtx-company/inter-app/src/redux/selectors/currentUserSelectors'
import { store } from '@dtx-company/inter-app/src/redux/store'

export const getDefaultFlowpageDomain = (): string => {
  const plan = selectCurrentUserPlan(store.getState())
  return getFlowpageHost(shouldUseFlowcodeDomain(plan))
}

export function shouldUseFlowcodeDomain(plan?: string): boolean {
  return isEnterprise(plan) || isGrowth(plan)
}

function isGrowth(plan?: string): boolean {
  return plan === OrgAccountType.PRO_FLEX
}

function isEnterprise(plan?: string): boolean {
  return plan === OrgAccountType.ENTERPRISE
}
